// PhotoSwipe ESM Loader (simplified)
// Directly imports ESM build using Shopify asset URL and exposes it on window + event.
(async () => {
  const PHOTO_SWIPE_ESM_PATH = '//neocell.co.uk/cdn/shop/t/2/assets/photoswipe.min.js?v=128169069546462557921778701468';
  try {
    const mod = await import(PHOTO_SWIPE_ESM_PATH);
    const PhotoSwipe = mod.default || mod.PhotoSwipe || mod;
    window.PhotoSwipe = PhotoSwipe;
    window.dispatchEvent(new CustomEvent('photoswipe-loaded', { detail: { PhotoSwipe } }));
    // Optional: verbose log can be removed in production
    console.debug('[PhotoSwipe] ESM loaded');
  } catch (err) {
    console.error('[PhotoSwipe] Failed to load ESM build:', err);
    window.dispatchEvent(new CustomEvent('photoswipe-error', { detail: { error: err } }));
  }
})();